import { BaseApiClient } from '../client'
import type {
  CreatorPayout,
  CreatePayoutInput,
  UpdatePayoutStatusInput,
  PaginatedApiResult,
} from '../types'

export class CreatorPayoutsApi extends BaseApiClient {
  async list(params?: {
    page?: number
    limit?: number
    creatorId?: string
    status?: string
  }): Promise<PaginatedApiResult<CreatorPayout>> {
    const searchParams = new URLSearchParams()
    if (params?.page) searchParams.set('page', params.page.toString())
    if (params?.limit) searchParams.set('limit', params.limit.toString())
    if (params?.creatorId) searchParams.set('creatorId', params.creatorId)
    if (params?.status) searchParams.set('status', params.status)

    const query = searchParams.toString()
    return this.request<PaginatedApiResult<CreatorPayout>>(
      `/api/admin/creator-payouts${query ? `?${query}` : ''}`
    )
  }

  async create(data: CreatePayoutInput): Promise<CreatorPayout> {
    return this.request<CreatorPayout>('/api/admin/creator-payouts', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async getById(id: string): Promise<CreatorPayout> {
    return this.request<CreatorPayout>(`/api/admin/creator-payouts/${id}`)
  }

  async updateStatus(id: string, data: UpdatePayoutStatusInput): Promise<CreatorPayout> {
    return this.request<CreatorPayout>(`/api/admin/creator-payouts/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
  }
}
